"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montegiorgio": {
    "5d009e2e": [{
      "hkey": "fc70f724",
      "slug": "montegiorgio",
      "name": "Montegiorgio",
      "primary": true,
      "skipSearch": false
    }],
    "cerreto": [{
      "hkey": "fc70f724",
      "slug": "montegiorgio",
      "name": "Montegiorgio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0a387e6d": [{
      "hkey": "4c4f58d9",
      "slug": "piane-di-montegiorgio",
      "name": "Piane di Montegiorgio",
      "primary": true,
      "skipSearch": false
    }],
    "piane": [{
      "hkey": "4c4f58d9",
      "slug": "piane-di-montegiorgio",
      "name": "Piane di Montegiorgio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;